<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
            </div>

            <div class="right-items"></div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="(e) => on_pagination_change(e, this.path)"
                size="middle"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
            >
                <template slot="author_render" slot-scope="text, record">
                    <div v-if="text">
                        {{ text.name }}
                        <br />
                        <small class="id">ID：{{ text.id }}</small>
                    </div>
                </template>
            </a-table>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import common_pagination from "../../../../mixins/common_pagination.js";

    export default {
        mixins: [common_pagination],
        data() {
            return {
                path: "/system/member_login",
                columns: [
                    {
                        dataIndex: "member_id",
                        title: "用户ID",
                        width: 100,
                    },
                    {
                        dataIndex: "member.name",
                        title: "用户姓名",
                        width: 100,
                    },
                    {
                        dataIndex: "organization.name",
                        title: "组织",
                        width: 100,
                    },
                    {
                        dataIndex: "ip",
                        title: "访问IP",
                        width: 130,
                    },
                    {
                        dataIndex: "action",
                        title: "操作信息",
                        width: 120,
                        ellipsis: true,
                    },
                    {
                        dataIndex: "ua",
                        title: "设备",
                        class: "small",
                        ellipsis: true,
                    },
                    {
                        dataIndex: "created_at",
                        title: "操作时间",
                        width: 145,
                        customRender: (e) => moment(e * 1000).format("YYYY-MM-DD HH:mm"),
                    },
                ],
                data_source: [],
                loading: false,
            };
        },
        mounted() {
            this.load();
        },
        watch: {
            $route() {
                this.load();
            },
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/system/log/member/login?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;

                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>
<style lang="less" scoped>
    .framework-body {
        .main {
            overflow-y: auto;
            position: absolute;
            top: 56px;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .id {
            color: #00000080;
        }
    }
</style>
